import axiosInstance from '@/utils/axios'

export default {
  list(params) {
    return axiosInstance.get('/admin/users', { params })
  },
  create(data) {
    return axiosInstance.post('/admin/users', data)
  },
  update(id, data) {
    return axiosInstance.put(`/admin/users/${id}`, data)
  },
  toggle(id) {
    return axiosInstance.patch(`/admin/users/${id}/toggle`)
  }
}
